import { domToReact } from "html-react-parser"

export const linkDomainExtractor = (link: string) => {
    let hostname
    // find & remove protocol (http, ftp, etc.) and get hostname
    if (link.indexOf("//") > -1) {
        hostname = link.split("/")[2]
    } else {
        hostname = link.split("/")[0]
    }

    // find & remove port number
    hostname = hostname.split(":")[0]
    // find & remove "?"
    hostname = hostname.split("?")[0]
    return hostname.replace("www.", "")
}

export const linkNodeTransform = (node: any) => {
    try {
        if (node.type === "tag" && node.name === "a") {
            node.children[0].data = linkDomainExtractor(node.children[0].data)
            return domToReact(node.children, { replace: linkNodeTransform })
        }
    } catch (err) {
        console.log(err)
    }

    return domToReact(node, { replace: linkNodeTransform })
}

export const extractTextFromHtml = (html: string) => {
    if (!html) {
        return ""
    }

    const temporalDivElement = document.createElement("div")
    temporalDivElement.innerHTML = html

    return temporalDivElement.textContent || temporalDivElement.innerText || html.replace(/<[^>]+>/g, "") || ""
}
